export default function valueCustomFields(this) {
  this.$root.$on('valueCustomFields', (items, type_field) => {
    this.data_repair[type_field] = items.map((el) => el.text).join(', ');
  });
}
